import {postRequest} from "./api";

export const getReferActions = observable => {
  const _observables = Array.isArray(observable) ? observable : [observable];

  return postRequest("/iroh/iroh-enrich/refer/observables", _observables);
};

export const getRespondActions = observable => {
  const _observables = Array.isArray(observable) ? observable : [observable];

  return postRequest("/iroh/iroh-response/respond/observables", _observables);
};

export const respondAction = (url, observable) => {
  const _observables = Array.isArray(observable) ? observable : [observable];

  return postRequest(`/iroh/iroh-response${url}`, _observables);
};
